<template>
  <transition name="fade">
    <div id="login-model-wrapper" v-show="modelShow" :key="getrans">
      <div
        class="login-model"
        ref="loginDialog"
        role="dialog"
        aria-modal="true"
        :aria-label="getrans('Sign in or create account')"
      >
        <button
          type="button"
          class="login-modal-close"
          :aria-label="getrans('Close')"
          @click="closeDialog"
        >
          <i class="fa fa-times" aria-hidden="true"></i>
        </button>

        <div class="tab-buttons" role="tablist">
          <button
            type="button"
            role="tab"
            :aria-selected="toggle_tab === 'signin'"
            aria-controls="login-panel-signin"
            @click="
              !otp_panel_showing
                ? ((toggle_tab = 'signin'),
                  (showOtpMethodSelection = false),
                  (showPasskeySection = false))
                : null
            "
            :class="toggle_tab === 'signin' ? `active` : ``"
          >
            {{ getrans("Sign In") }}
          </button>
          <button
            type="button"
            role="tab"
            :aria-selected="toggle_tab === 'create'"
            aria-controls="login-panel-create"
            @click="
              !otp_panel_showing
                ? ((toggle_tab = 'create'),
                  (showOtpMethodSelection = false),
                  (showPasskeySection = false))
                : null
            "
            :class="toggle_tab === 'create' ? `active` : ``"
          >
            {{ getrans("Create Account") }}
          </button>
        </div>

        <div
          class="content"
          v-show="toggle_tab === 'signin'"
          role="tabpanel"
          id="login-panel-signin"
        >
          <template v-if="!otp_panel_showing">
            <div>
              <p>
                {{
                  getrans(
                    "Sign in for easier bookings, earn points on parking, redeem points for discounts, and manage your bookings anytime."
                  )
                }}
              </p>
              <p>
                <b>{{
                  getrans(
                    "If you made a booking as a guest, enter the email address you used to retrieve your key documents."
                  )
                }}</b>
              </p>
            </div>

            <div class="block-wrap" style="width: 100%">
              <div
                class="block"
                :class="`${loginemail ? 'hasValue tick' : ''} ${
                  errors.loginemail ? 'error' : ''
                }`"
              >
                <input
                  type="text"
                  id="loginemail"
                  v-model="loginemail"
                  placeholder="Ex. johnsmith@example.com"
                  autocomplete="username"
                  @blur="validateEmail('loginemail')"
                />
                <label for="loginemail"
                  >{{ getrans("Email Address")
                  }}<span class="form-mandatory">*</span></label
                >
                <div v-if="errors.loginemail" class="error-message">
                  {{ getrans(errors.loginemail) }}
                </div>
              </div>
            </div>
            <div style="clear: both"></div>
            <div v-if="showOtpMethodSelection" class="otp-method-selection">
              <p style="text-align: center; font-weight: bold">
                {{ getrans("Choose how to receive your verification code") }}
              </p>
              <div class="method-buttons">
                <button @click="selectOtpMethod('email')" class="proceed">
                  <i class="fa fa-envelope"></i>&nbsp;&nbsp;
                  {{ getrans("Send to Email") }}
                </button>
                <button @click="selectOtpMethod('sms')" class="proceed">
                  <i class="fa fa-mobile"></i>&nbsp;&nbsp;
                  {{ getrans("Send to Mobile") }}
                </button>
              </div>
            </div>
            <div class="login-buttons" v-if="!showOtpMethodSelection">
              <button
                v-if="!showLoginRegistration"
                @click="handleLogin('otp')"
                class="proceed"
                :disabled="loginSubmitting || showOtpMethodSelection"
              >
                <span v-if="loginSubmitting && !showOtpMethodSelection">
                  <i class="fa fa-spinner fa-spin"></i
                  >&nbsp;&nbsp;{{ getrans("Checking...") }}
                </span>
                <span v-else>{{ getrans("Sign In") }}</span>
              </button>

              <!-- Login with Device button -->
              <WebAuthnLogin
                v-if="!showLoginRegistration"
                :username="loginemail"
                :brand_id="setbrandid"
                @login-complete="handleLoginSuccess"
                @login-error="onLoginError"
                @fetch-user-details="handlePostLoginFlow"
              />

              <div
                v-if="showLoginRegistration"
                class="login-registration-fallback"
              >
                <div v-if="!passkeyEmailVerified" class="info-message">
                  <i class="fa fa-info-circle"></i>
                  <p>
                    {{
                      getrans(
                        "To register a passkey, you must first verify your email ownership."
                      )
                    }}
                  </p>
                </div>
                
                <!-- Email Verification Step -->
                <div v-if="!passkeyEmailVerified" class="email-verification">
                  <div v-if="!passkeyOtpSent">
                    <p>{{ getrans("Please verify this email address to register your passkey") }}</p>
                    <button @click="sendLoginPasskeyVerificationOtp" class="verify-email-btn">
                      {{ getrans("Send Verification Code") }}
                    </button>
                  </div>
                  <div v-else>
                    <p>{{ getrans("Enter the verification code sent to your email") }}</p>
                    <input
                      type="text"
                      v-model="passkeyOtpCode"
                      placeholder="Enter 6-digit code"
                      maxlength="6"
                      class="otp-input"
                    />
                    <button @click="verifyLoginPasskeyEmail" class="verify-code-btn">
                      {{ getrans("Verify Code") }}
                    </button>
                  </div>
                </div>
                
                <!-- Verification Success Message -->
                <div v-if="passkeyEmailVerified" class="verification-success">
                  <div class="success-message">
                    <i class="fa fa-check-circle"></i>
                    <p>{{ getrans("Email verification successful! You can now proceed with passkey registration.") }}</p>
                  </div>
                </div>
                
                <WebAuthnRegister
                  v-if="passkeyEmailVerified"
                  :username="loginemail"
                  :brand_id="setbrandid"
                  @registration-complete="onLoginRegistrationComplete"
                />
                <button
                  @click="showLoginRegistration = false; resetPasskeyVerification()"
                  class="back-to-login"
                >
                  {{ getrans("Back to Login") }}
                </button>
              </div>
            </div>
          </template>

          <template v-else>
            <p>
              {{
                getrans(
                  otpSentMethod === 'sms'
                    ? "We've sent a 6 digit verification code to your mobile."
                    : "We've sent a 6 digit verification code to (email address)."
                )
              }}
            </p>
            <div v-if="showCrossDeviceOption" class="cross-device-option">
              <p>
                {{ getrans("Continue on your phone to auto-fill the code") }}
              </p>
              <button @click="generateCrossDeviceLink" class="cross-device-btn">
                <i class="fa fa-mobile"></i>&nbsp;&nbsp;
                {{ getrans("Continue on Phone") }}
              </button>
            </div>
            <OTPInput
              v-on:opt_change="opt_change"
              :otpLength="6"
              :autocomplete="otpSentMethod === 'sms' ? 'one-time-code' : ''"
              :inputmode="'numeric'"
              ref="otpInput"
            />
            <RememberDeviceComponent
              v-model="rememberDevice"
              :brand-slug="setbrandid"
            />
            <p>
              {{ getrans("Did not get code?") }}&nbsp;
              <a href="#" @click.prevent="otp_panel_showing = false">
                {{ getrans("Try again") }}
              </a>
            </p>
            <!-- <button @click="handleLogin('verify')" class="proceed">
              {{ getrans("Sign In") }}
            </button> -->

            <button
              type="button"
              @click="handleLogin('verify')"
              class="proceed"
              :disabled="formSubmitting"
            >
              <span v-if="formSubmitting"
                ><i class="fa fa-spinner fa-spin"></i
                >&nbsp;&nbsp;{{ getrans("Signing In...") }}</span
              >
              <span v-else>{{ getrans("Sign In") }}</span>
            </button>
          </template>
        </div>

        <div
          class="content"
          v-show="toggle_tab === 'create'"
          role="tabpanel"
          id="login-panel-create"
        >
          <template v-if="showPasskeySection">
            <div class="passkey-section">
              <div class="divider">
                <span
                  >{{ getrans("We recommend you register this device for faster logins & best in class security. To register a passkey, you must first verify your email ownership.") }}</span
                >
              </div>
              <div class="form-group">
                <label for="regUsername">Email Address:</label>
                <input
                  type="text"
                  id="regUsername"
                  v-model="regUsername"
                  placeholder="Ex. johnsmith@example.com"
                  autocomplete="username"
                  @blur="validateEmail('regUsername')"
                  :disabled="passkeyEmailVerified"
                />
                <div v-if="errors.regUsername" class="error-message">
                  {{ getrans(errors.regUsername) }}
                </div>
              </div>

              <!-- Email Verification Step -->
              <div v-if="!passkeyEmailVerified && regUsername && !errors.regUsername" class="email-verification">
                <div v-if="!passkeyOtpSent">
                  <p>{{ getrans("Please verify this email address to register your passkey") }}</p>
                  <button @click="sendPasskeyVerificationOtp" class="verify-email-btn">
                    {{ getrans("Send Verification Code") }}
                  </button>
                </div>
                <div v-else>
                  <p>{{ getrans("Enter the verification code sent to your email") }}</p>
                  <input
                    type="text"
                    v-model="passkeyOtpCode"
                    placeholder="Enter 6-digit code"
                    maxlength="6"
                    class="otp-input"
                  />
                  <button @click="verifyPasskeyEmail" class="verify-code-btn">
                    {{ getrans("Verify Code") }}
                  </button>
                </div>
              </div>
              
              <!-- Verification Success Message -->
              <div v-if="passkeyEmailVerified && !registrationSuccessful" class="verification-success">
                <div class="success-message">
                  <i class="fa fa-check-circle"></i>
                  <p>{{ getrans("Email verification successful! You can now proceed with passkey registration.") }}</p>
                </div>
              </div>

              <WebAuthnRegister
                v-if="passkeyEmailVerified && !registrationSuccessful"
                :username="regUsername"
                :brand_id="setbrandid"
                @registration-complete="onRegistrationComplete"
              />

              <div v-if="registrationSuccessful" class="registration-success">
                <div class="success-message">
                  <i class="fa fa-check-circle"></i>
                  <h4>{{ getrans("Registration Successful!") }}</h4>
                  <p>
                    {{
                      getrans("Your passkey has been registered successfully.")
                    }}
                  </p>
                </div>
              </div>

              <button
                @click="(modelShow = false)" 
                class="proceed"
                v-if="passkeyEmailVerified || registrationSuccessful"
              >
                {{ getrans("Continue") }}
              </button>
              <button
                @click="(modelShow = false)" 
                class="skip-passkey"
                v-if="!passkeyEmailVerified && !registrationSuccessful"
              >
                {{ getrans("Skip for now") }}
              </button>
            </div>
          </template>

          <template v-else-if="otp_panel_showing">
            <p>
              {{
                getrans(
                  otpSentMethod === 'sms'
                    ? "We've sent a 6 digit verification code to your mobile."
                    : "We've sent a 6 digit verification code to (email address)."
                )
              }}
            </p>
            <OTPInput v-on:opt_change="opt_change" :otpLength="6" />
            <RememberDeviceComponent
              v-model="rememberDevice"
              :brand-slug="setbrandid"
            />
            <p>
              {{ getrans("Did not get code?") }}&nbsp;
              <a href="#" @click.prevent="otp_panel_showing = false">
                {{ getrans("Try again") }}
              </a>
            </p>
            <button @click="handleLogin('verify')" class="proceed">
              {{ getrans("Sign In") }}
            </button>
          </template>

          <template v-else>
            <div class="content-box">
              <p>
                <b>{{ getrans("Create an account to:") }}</b>
              </p>
              <ul>
                <li>{{ getrans("Join as a Loyalty Member") }}</li>
                <li>{{ getrans("Unlock exclusive perks") }}</li>
                <li>
                  {{ getrans("Redeem points for savings on future bookings") }}
                </li>
              </ul>
            </div>

            <h3>{{ getrans("Your Details") }}</h3>
            <div class="block-wrap" style="width: 100%">
              <div
                class="block"
                :class="`${firstname ? 'hasValue tick' : ''} ${
                  errors.firstname ? 'error' : ''
                }`"
              >
                <input
                  type="text"
                  id="firstname"
                  v-model="firstname"
                  placeholder="Ex. John"
                  autocomplete="given-name"
                  @input="validateField('firstname')"
                  @blur="validateField('firstname')"
                />
                <label for="firstname"
                  >{{ getrans("First Name")
                  }}<span class="form-mandatory">*</span></label
                >
                <div v-if="errors.firstname" class="error-message">
                  {{ getrans(errors.firstname) }}
                </div>
              </div>
            </div>

            <div class="block-wrap" style="width: 100%">
              <div
                class="block"
                :class="`${surname ? 'hasValue tick' : ''} ${
                  errors.surname ? 'error' : ''
                }`"
              >
                <input
                  type="text"
                  id="lastname"
                  v-model="surname"
                  placeholder="Ex. Smith"
                  autocomplete="family-name"
                  @input="validateField('surname')"
                  @blur="validateField('surname')"
                />
                <label for="surname"
                  >{{ getrans("Last Name")
                  }}<span class="form-mandatory">*</span></label
                >
                <div v-if="errors.surname" class="error-message">
                  {{ getrans(errors.surname) }}
                </div>
              </div>
            </div>

            <div class="block-wrap" style="width: 100%">
              <div
                class="block"
                :class="`${email ? 'hasValue tick' : ''} ${
                  errors.email ? 'error' : ''
                }`"
              >
                <input
                  type="text"
                  id="email"
                  v-model="email"
                  placeholder="Ex. johnsmith@example.com"
                  autocomplete="email"
                  @blur="validateEmail('email')"
                />
                <label for="email"
                  >{{ getrans("Email Address")
                  }}<span class="form-mandatory">*</span></label
                >
                <div v-if="errors.email" class="error-message">
                  {{ getrans(errors.email) }}
                </div>
              </div>
            </div>

            <p
              style="
                color: #e00b27;
                display: block;
                width: 100%;
                text-align: center;
                font-weight: bold;
              "
            >
              {{ getrans("No password required. Quicker sign-in, no hassle!") }}
            </p>

            <div class="block-wrap" style="width: 100%">
              <div
                class="input-checkbox"
                :class="`${errors.term_condition ? 'error' : ''}`"
              >
                <input
                  class="checkmark-style"
                  type="checkbox"
                  name="term_condition"
                  v-model="term_condition"
                  id="term_condition"
                  @change="validateField('term_condition')"
                />
                <label for="term_condition">
                  * Click here to accept
                  <a target="_blank" :href="terms_and_conditions_link">{{
                    getrans("Terms & Conditions")
                  }}</a>
                  which includes privacy information as to data collection and
                  usage.
                </label>
                <div v-if="errors.term_condition" class="error-message">
                  {{ getrans(errors.term_condition) }}
                </div>
              </div>
            </div>

            <div class="block-wrap" style="width: 100%">
              <div class="input-checkbox">
                <input
                  class="checkmark-style"
                  type="checkbox"
                  name="email_consent"
                  v-model="email_consent"
                  value="0"
                  id="email_consent"
                />
                <label for="email_consent_disabled">
                  I opt-In to receive communication from Los Angeles World
                  Airports including information on exclusive offers and new
                  services. Visit our
                  <a target="_blank" :href="privacy_policy_link"
                    >Privacy Notice</a
                  >
                  to learn more.
                </label>
              </div>
            </div>

            <button
              type="button"
              @click="handleLogin('create')"
              class="proceed"
              :disabled="formSubmitting"
            >
              <span v-if="formSubmitting"
                ><i class="fa fa-spinner fa-spin"></i
                >&nbsp;&nbsp;{{ getrans("Creating Account...") }}</span
              >
              <span v-else>{{ getrans("Create Account") }}</span>
            </button>
          </template>

        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import OTPInput from "./OTPInput.vue";
import RememberDeviceComponent from "./RememberDeviceComponent.vue";
import WebAuthnLogin from "./webauthn/WebAuthnLogin.vue";
import WebAuthnRegister from "./webauthn/WebAuthnRegister.vue";
import { activateFocusTrap } from "@/utils/focusTrap";
import axios from "axios";
import Swal from "sweetalert2";
const genkeys = require("rezauthlib");
const { EncryptStorage } = require("encrypt-storage");
const encryptStorage = new EncryptStorage(process.env.VUE_APP_CHL, {
  storageType: "sessionStorage",
});
const crypto = require("crypto");

export default {
  name: "LoginModelNew",
  props: {
    setbrandid: {
      type: String,
      required: false
    },
    getransfn: {
      type: Function,
      required: false
    },
    lang: {
      type: String,
      required: false,
      default: 'EN'
    }
  },
  components: {
    OTPInput,
    RememberDeviceComponent,
    WebAuthnLogin,
    WebAuthnRegister,
  },

  data() {
    return {
      modelShow: false,
      deactivateFocusTrap: null,
      otp_panel_showing: false,
      toggle_tab: "signin",
      loginemail: "",
      regUsername: "",
      firstname: "",
      surname: "",
      email: "",
      password: "",
      term_condition: false,
      email_consent: false,
      rememberDevice: false,
      loginSubmitting: false,
      formSubmitting: false,
      registrationSuccessful: false,
      showLoginRegistration: false,
      showOtpMethodSelection: false,
      selectedOtpMethod: null,
      pendingLoginData: null,
      otpSentMethod: null,
      showPasskeySection: false,
      passkeyEmailVerified: false,
      passkeyOtpSent: false,
      passkeyOtpCode: "",
      passkeySessionToken: null,
      // Web OTP specific
      webOtpSupported: false,
      webOtpController: null,
      showCrossDeviceOption: false,
      crossDeviceSessionId: null,
      terms_and_conditions_link: "",
      privacy_policy_link: "",
      errors: {
        loginemail: null,
        regUsername: null,
        firstname: null,
        surname: null,
        email: null,
        term_condition: null,
      },
    };
  },

  computed: {
    hasValidationErrors() {
      return (
        this.errors.firstname ||
        this.errors.surname ||
        this.errors.email ||
        this.errors.term_condition ||
        !this.firstname ||
        !this.surname ||
        !this.email ||
        !this.term_condition
      );
    },
  },

  watch: {
    // Activate the focus trap when the dialog opens; on close (any path)
    // release it and return focus to the header trigger.
    modelShow(visible) {
      if (visible) {
        this.$nextTick(() => {
          this.deactivateFocusTrap = activateFocusTrap(
            this.$refs.loginDialog,
            this.closeDialog
          );
        });
      } else if (this.deactivateFocusTrap) {
        this.deactivateFocusTrap();
        this.deactivateFocusTrap = null;
        this.restoreFocusToTrigger();
      }
    },
  },

  methods: {
    // Same state resets as the old close icon; used by the close button
    // and the focus trap's Escape handler.
    closeDialog() {
      this.modelShow = false;
      this.showOtpMethodSelection = false;
      this.otp_panel_showing = false;
      this.showPasskeySection = false;
    },

    restoreFocusToTrigger() {
      const trigger = document.getElementById("sign-in-trigger");
      if (trigger && trigger.isConnected) {
        trigger.focus();
      }
    },

    reloadPage() {
      window.location.reload();
    },

    getrans(key) {
      if (this.getransfn && typeof this.getransfn === 'function') {
        return this.getransfn(key);
      }
      return key; // Fallback: return the key itself if no function provided
    },

    opt_change(value) {
      this.password = value;
    },

    // Web OTP Detection
    checkWebOtpSupport() {
      this.webOtpSupported =
        "OTPCredential" in window &&
        "navigator" in window &&
        "credentials" in navigator;
      return this.webOtpSupported;
    },

    // Web OTP Implementation
    async requestWebOtp() {
      if (!this.webOtpSupported || this.otpSentMethod !== "sms") return;

      try {
        this.webOtpController = new AbortController();

        const credential = await navigator.credentials.get({
          otp: { transport: ["sms"] },
          signal: this.webOtpController.signal,
        });

        if (credential && credential.code) {
          this.password = credential.code;
          // Auto-trigger verification
          await this.handleLogin("verify");
        }
      } catch (error) {
        if (error.name === "AbortError") {
          console.log("Web OTP request aborted");
        } else if (error.name === "NotSupportedError") {
          console.log("Web OTP not supported");
        } else {
          console.error("Web OTP error:", error);
        }
      }
    },

    // Cross-device OTP
    generateCrossDeviceSessionId() {
      return crypto.randomBytes(16).toString("hex");
    },

    generateCrossDeviceLink() {
      this.crossDeviceSessionId = this.generateCrossDeviceSessionId();
      const baseUrl = window.location.origin;
      const crossDeviceUrl = `${baseUrl}/verify-otp?session=${this.crossDeviceSessionId}`;

      // Store session data for cross-device verification
      sessionStorage.setItem(
        `cross_device_${this.crossDeviceSessionId}`,
        JSON.stringify({
          email: this.loginemail,
          uuid: this.pendingLoginData?.uuid,
          timestamp: Date.now(),
        })
      );

      // Open URL or show QR code
      if (navigator.share) {
        navigator.share({
          title: "Continue Login",
          url: crossDeviceUrl,
        });
      } else {
        window.open(crossDeviceUrl, "_blank");
      }
    },

    // Handle deep link OTP
    handleDeepLinkOtp() {
      const urlParams = new URLSearchParams(window.location.search);
      const sessionId = urlParams.get("session");
      const otpCode = urlParams.get("otp");

      if (sessionId && otpCode) {
        const sessionData = sessionStorage.getItem(`cross_device_${sessionId}`);
        if (sessionData) {
          const data = JSON.parse(sessionData);
          // Verify timestamp (expire after 10 minutes)
          if (Date.now() - data.timestamp < 600000) {
            this.password = otpCode;
            this.loginemail = data.email;
            this.pendingLoginData = { uuid: data.uuid };
            this.handleLogin("verify");
          }
          sessionStorage.removeItem(`cross_device_${sessionId}`);
        }
      }
    },

    // Unified email validation
    validateEmail(field) {
      this.errors[field] = null;
      const value = this[field];

      if (!value) {
        this.errors[field] = "Email is required";
        return false;
      }

      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(value)) {
        this.errors[field] = "Please enter a valid email address";
        return false;
      }

      // Additional validation for registration email
      // Note: existence check is handled in validateRegistrationForm()

      // Reset passkey email verification if email changes
      if (field === "regUsername") {
        this.passkeyEmailVerified = false;
        this.passkeyOtpSent = false;
        this.passkeyOtpCode = "";
      }

      return true;
    },

    // Unified field validation
    validateField(field) {
      this.errors[field] = null;

      switch (field) {
        case "firstname":
        case "surname":
          if (!this[field] || !this[field].trim()) {
            this.errors[field] = `${
              field === "firstname" ? "First" : "Last"
            } name is required`;
            return false;
          }

          if (!/^[A-Za-z' -]+$/.test(this[field].trim())) {
            this.errors[field] = `${
              field === "firstname" ? "First" : "Last"
            } name can only contain letters, spaces, apostrophes, and hyphens`;
            return false;
          }
          break;
        case "term_condition":
          if (!this.term_condition) {
            this.errors[field] = "You must accept the Terms & Conditions";
            return false;
          }
          break;
      }
      return true;
    },

    // Unified login handler
    async handleLogin(type) {
      try {
        switch (type) {
          case "otp":
            await this.handleOTPLogin();
            break;
          case "verify":
            await this.handleOTPVerification();
            break;
          case "create":
            await this.handleAccountCreation();
            break;
        }
      } catch (error) {
        console.error(`${type} login error:`, error);
        this.showError("An error occurred. Please try again.");
      }
    },

    async handleOTPLogin() {
      if (!this.validateEmail("loginemail")) return;

      this.loginSubmitting = true;
      const isValid = await this.checkUserForLogin(this.loginemail);

      if (!isValid) {
        this.errors.loginemail = "This email is not registered or invalid";
        this.showError(this.errors.loginemail);
        this.loginSubmitting = false;
        return;
      }

      // Only show OTP panel if method selection is not shown
      if (!this.showOtpMethodSelection) {
        this.otp_panel_showing = true;
        this.loginSubmitting = false;

        // Initialize Web OTP for SMS
        if (this.otpSentMethod === "sms") {
          this.requestWebOtp();
          this.showCrossDeviceOption = !this.webOtpSupported;
        }
      }
    },

    async handleOTPVerification() {
      if (!this.password) {
        this.showError("Please enter valid code.");
        return;
      }
      this.formSubmitting = true;

      // Cancel Web OTP request if active
      if (this.webOtpController) {
        this.webOtpController.abort();
        this.webOtpController = null;
      }

      let response;
      if (this.otpSentMethod === "sms") {
        const uuid = this.pendingLoginData?.uuid || this.getLocalData("uuid");
        const device_id = this.genHash(this.loginemail || this.email);
        response = await this.verifyMobileOTP(uuid, this.password, device_id);
      } else {
        const emailentered =
          this.toggle_tab === "signin" ? this.loginemail : this.email;
        response = await this.verifyOTP(emailentered, this.password);
      }

      if (response.success) {
        await this.handlePostLoginFlow(response.uuid);
      } else {
        this.showError("Invalid code. Please try again.");
        this.formSubmitting = false;
      }
    },

    async handleAccountCreation() {
      if (!(await this.validateRegistrationForm())) return;

      this.formSubmitting = true;
      const response = await this.createUserAccount();

      if (response.success) {
        await this.sendOtp(this.email);
        this.otp_panel_showing = true;
      }
      this.formSubmitting = false;
    },

    async validateRegistrationForm() {
      const fields = ["firstname", "surname", "email", "term_condition"];
      let isValid = true;

      fields.forEach((field) => {
        if (field === "email") {
          if (!this.validateEmail(field)) isValid = false;
        } else {
          if (!this.validateField(field)) isValid = false;
        }
      });

      if (isValid) {
        const exists = await this.checkUserExists(this.email);
        if (exists) {
          this.errors.email = "This email is already registered";
          isValid = false;
        }
      }

      return isValid;
    },

    // Unified post-login flow
    async handlePostLoginFlow(uuid) {
      try {
        this.setLocalData("uuid", uuid);
        const userDetails = await this.fetchUserDetails(uuid);

        if (userDetails.user_exists === "Y") {
          this.updateUserData(userDetails.result[0]);
          this.enw_log();

          // Handle remember device
          if (this.rememberDevice) {
            await this.handleRememberDevice(uuid);
          }
          // Show passkey section only if coming from create account flow
          if (this.toggle_tab === "create") {
            
            this.showPasskeySection = true;
            this.otp_panel_showing = false;
            // Pre-fill with verified email and mark as verified
            this.regUsername = this.email;
            this.passkeyEmailVerified = true;
          } else {
            this.modelShow = false;
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          }
        } else {
          this.showError("User not found, please contact administrator");
        }
      } catch (error) {
        console.error("Post-login flow error:", error);
        this.showError("Error fetching user details");
      }
    },

    async handleRememberDevice(uuid) {
      try {
        const RememberDevice = (await import("@/modules/RememberDevice"))
          .default;
        await RememberDevice.rememberDevice(
          uuid,
          this.loginemail || this.email
        );
      } catch (error) {
        console.error("Remember device error:", error);
      }
    },

    // WebAuthn event handlers
    handleLoginSuccess(authToken) {
      this.$emit("webauthn-login-success", authToken);
    },

    onLoginError(error) {
      console.error("error", error);
      
      // Check if it's a rate limiting error
      if (error && error.includes && error.includes('Rate limit exceeded')) {
        this.showError(error);
        return;
      }
      
      // Check if it's an account locked error
      if (error && error.includes && error.includes('Account temporarily locked')) {
        this.showError(error);
        return;
      }
      
      // For other errors, show registration fallback
      this.resetPasskeyVerification();
      this.showLoginRegistration = true;
    },

    onRegistrationComplete() {
      this.registrationSuccessful = true;
      this.$emit("webauthn-registration-success", this.regUsername);
    },

    onLoginRegistrationComplete() {
      this.showLoginRegistration = false;
      Swal.fire({
        icon: "success",
        title: "Registration Successful!",
        text: "Your passkey has been registered. You can now login.",
        confirmButtonColor: "#034a94",
      });
    },

    // API calls
    async checkUserExists(email) {
      return this.makeUserCheckRequest(email, false);
    },

    async checkUserForLogin(email) {
      const result = await this.makeUserCheckRequest(email, true);
      if (result.valid && result.msg) {
        if (result.msg.send_sms && result.msg.send_email) {
          // Show user choice between SMS and Email
          this.pendingLoginData = { email, uuid: result.msg.uuid };
          this.showOtpMethodSelection = true;
          let bid = ["SB3", "SB4", "SB5"].includes(this.setbrandid) ? "SB2" : this.setbrandid;
          if(bid=='SB2')
          {
          this.showOtpMethodSelection = false;
          await this.sendOtp(email);
          this.otpSentMethod = "email";          
          }
          return result.valid;
        } else if (result.msg.send_sms) {
          await this.sendMobileOtp(result.uuid);
          this.otpSentMethod = "sms";
        } else {
          await this.sendOtp(email);
          this.otpSentMethod = "email";
        }
      }
      return result.valid;
    },

    async makeUserCheckRequest(email, forLogin = false) {
      const { b1s, v2s, a1, v1, c2s, uidgen } = genkeys(
        process.env.VUE_APP_VERIFYEMAIL_SID,
        process.env.VUE_APP_VERIFYEMAIL_SKEY
      );

      const ur =
        this.setbrandid === "HER"
          ? `${process.env.VUE_APP_DOMAIN_DEVAWS_FRA}sso/email/verify/exist`
          : `${process.env.VUE_APP_DOMAIN_DEVAWS}sso/frontend/email/verify/exist`;

      try {
        const response = await axios.post(
          ur,
          {
            brand_id: ["SB3", "SB4", "SB5"].includes(this.setbrandid) ? "SB2" : this.setbrandid,
            email_id: email,
          },
          {
            headers: { b1: b1s, v2: v2s, c2s, a1, v1, c1: uidgen },
          }
        );

        const data = JSON.parse(response.request.response);
        const code = data.code?.toString();
        const msg = data.msg ?? data.data;
        const uuid = data?.msg?.uuid ?? data?.data?.uuid;
        const userExistsFlag = msg?.user_exists;
        const userExists = userExistsFlag === "Y";

        if (forLogin) {
          return {
            valid: code === "1" && userExists,
            msg,
            uuid,
          };
        }

        if (code === "1") return userExists; // exists = true
        if (code === "37") return false; // does not exist
        return false;
      } catch (error) {
        return false;
      }
    },

    async sendOtp(email) {
      const { b1s, v2s, a1, v1, c2s, uidgen } = genkeys(
        process.env.VUE_APP_OTP_SECRETID,
        process.env.VUE_APP_OTP_SECRETKEY
      );

      const ur =
        this.setbrandid === "HER"
          ? `${process.env.VUE_APP_DOMAIN_DEVAWS_FRA}sso/email/login/otp/send`
          : `${process.env.VUE_APP_DOMAIN_DEVAWS}sso/frontend/email/login/otp/send`;

      return axios.post(
        ur,
        {
          brand_id: ["SB3", "SB4", "SB5"].includes(this.setbrandid) ? "SB2" : this.setbrandid,
          email_id: email,
          language: (this.lang || "EN").toUpperCase(),
          lang: (this.lang || "EN").toUpperCase(),
        },
        {
          headers: { b1: b1s, v2: v2s, c2s, a1, v1, c1: uidgen },
        }
      );
    },

    async sendMobileOtp(uuid) {
      const { b1s, v2s, a1, v1, c2s, uidgen } = genkeys(
        process.env.VUE_APP_OTP_SECRETID,
        process.env.VUE_APP_OTP_SECRETKEY
      );

      return axios.post('https://devapi.rezcomm.com/sso/mobile/login/otp/send', {
        uid: uuid,
        brand_id: ["SB3", "SB4", "SB5"].includes(this.setbrandid) ? "SB2" : this.setbrandid,
        language: (this.lang || "EN").toUpperCase(),
        lang: (this.lang || "EN").toUpperCase(),
      }, {
        headers: { b1: b1s, v2: v2s, c2s, a1, v1, c1: uidgen }
      });
    },

    async verifyMobileOTP(uuid, otp, device_id) {
      const { b1s, v2s, a1, v1, c2s, uidgen } = genkeys(
        process.env.VUE_APP_OTP_SECRETID,
        process.env.VUE_APP_OTP_SECRETKEY
      );

      try {
        const response = await axios.post(
          "https://devapi.rezcomm.com/sso/auth/login",
          {
            uuid: uuid,
            device_id: device_id,
            otp_code: otp,
            brand_id: ["SB3", "SB4", "SB5"].includes(this.setbrandid) ? "SB2" : this.setbrandid,
            language: (this.lang || "EN").toUpperCase(),
            lang: (this.lang || "EN").toUpperCase(),
          },
          {
            headers: { b1: b1s, v2: v2s, c2s, a1, v1, c1: uidgen },
          }
        );

        const data = JSON.parse(response.request.response);
        return {
          success: data.code?.toString() === "1",
          uuid: data.msg?.user_det?.uuid?.toString(),
        };
      } catch (error) {
        return { success: false };
      }
    },

    async verifyOTP(email, otp) {
      const { b1s, v2s, a1, v1, c2s, uidgen } = genkeys(
        process.env.VUE_APP_LOGIN_SECRETID,
        process.env.VUE_APP_LOGIN_SECRETKEY
      );

      const ur = `${process.env.VUE_APP_DOMAIN_DEVAWS}sso/frontend/auth/login`;

      try {
        const response = await axios.post(
          ur,
          {
            brand_id: ["SB3", "SB4", "SB5"].includes(this.setbrandid) ? "SB2" : this.setbrandid,
            login_id: email,
            otp_code: otp,
            device_id: this.genHash(email),
            language: (this.lang || "EN").toUpperCase(),
            lang: (this.lang || "EN").toUpperCase(),
          },
          {
            headers: { b1: b1s, v2: v2s, c2s, a1, v1, c1: uidgen },
          }
        );

        const data = JSON.parse(response.request.response);
        return {
          success: data.code?.toString() === "1",
          uuid: data.msg?.user_det?.uuid?.toString(),
        };
      } catch (error) {
        return { success: false };
      }
    },

    async createUserAccount() {
      const { b1s, v2s, a1, v1, c2s, uidgen } = genkeys(
        process.env.VUE_APP_OTP_SECRETID,
        process.env.VUE_APP_OTP_SECRETKEY
      );

      try {
        const response = await axios.post(
          "https://devapi-london.rezcomm.com/devssoreg/register",
          {
            firstname: this.firstname,
            surname: this.surname,
            email: this.email,
            termsAccepted: this.term_condition,
            emailConsent: this.email_consent,
            slug: ["SB3", "SB4", "SB5"].includes(this.setbrandid) ? "SB2" : this.setbrandid,
          },
          {
            headers: { b1: b1s, v2: v2s, c2s, a1, v1, c1: uidgen },
          }
        );

        return { success: response.data?.success };
      } catch (error) {
        this.showError(
          error.response?.data?.message || "Account creation failed"
        );
        return { success: false };
      }
    },

    async fetchUserDetails(uuid) {
      const isHER = this.setbrandid === "HER";
      const { b1s, v2s, a1, v1, c2s, uidgen } = genkeys(
        isHER
          ? process.env.VUE_APP_USERDET_SECRETID_FRA
          : process.env.VUE_APP_USERDET_SECRETID,
        isHER
          ? process.env.VUE_APP_USERDET_SECRETKEY_FRA
          : process.env.VUE_APP_USERDET_SECRETKEY
      );

      const ur = isHER
        ? process.env.VUE_APP_DOMAIN_DEVAWS_FRA
        : process.env.VUE_APP_DOMAIN_DEVAWS;

      const response = await axios.post(
        ur + "userdetails/",
        {
          slug: ["SB3", "SB4", "SB5"].includes(this.setbrandid) ? "SB2" : this.setbrandid,
          uid: uuid,
        },
        {
          headers: { b1: b1s, v2: v2s, c2s, a1, v1, c1: uidgen },
        }
      );

      return JSON.parse(response.request.response);
    },

    updateUserData(userdata) {
      this.enw_log();
      sessionStorage.setItem("session_uuid", userdata.uuid);
      encryptStorage.setItem("session_userdata", userdata);

      Object.entries({
        title: userdata.title,
        companyname: userdata.companyname || "",
        firstname: decodeURI(userdata.first_name),
        surname: decodeURI(userdata.last_name),
        email: userdata.email,
        email_consent_exists: userdata.email_consent,
        email_consent: userdata.email_consent,
        email_confirm: userdata.email,
        address: decodeURI(decodeURI(userdata.address_line_1)),
        address_line_2: decodeURI(decodeURI(userdata.address_line_2)),
        postcode: decodeURI(userdata.post_code),
        state: decodeURI(userdata.state),
        town: decodeURI(userdata.city),
        phonecode: userdata.phonecode,
        mobilenumber: userdata.mobilenumber,
      }).forEach(([key, value]) => (this[key] = value));

      // Trigger header update
      window.dispatchEvent(new CustomEvent("userLoggedIn"));
    },

    enw_log() {
      const chdata =
        process.env.VUE_APP_CHL +
        (["SB3", "SB4", "SB5"].includes(this.setbrandid) ? "SB2" : this.setbrandid).toLowerCase() +
        this.getLocalData("uuid");
      const hash = crypto.createHash("sha512");
      const transaction_token = hash.update(chdata, "utf-8").digest("hex");

      const { b1s, v2s, a1, v1, c2s, uidgen } = genkeys(
        process.env.VUE_APP_BRNDDET_SECRETID,
        process.env.VUE_APP_BRNDDET_SECRETKEY
      );

      axios
        .post(
          process.env.VUE_APP_DOMAIN_DEVHUB + "hubapmydbauth/dev_alog/enw.php",
          {
            uuid: this.getLocalData("uuid"),
            brand_id: (["SB3", "SB4", "SB5"].includes(this.setbrandid) ? "SB2" : this.setbrandid).toLowerCase(),
            orderreference: this.orderreference,
            transaction_token,
            timestamp: Date.now(),
          },
          {
            headers: {
              b1: b1s,
              v2: v2s,
              c2s,
              a1,
              v1,
              c1: uidgen,
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          if (response?.data?.user_exists === "Y" && response.data.data) {
            encryptStorage.setItem("enw_log_key", response.data.data);
            encryptStorage.setItem("mmb_link", response.data.mmb_link);
          }
        })
        .catch((error) => console.error("Authentication error", error));
    },

    // Utility functions
    genHash(str) {
      let hash = 0;
      if (str.length === 0) return hash;
      for (let i = 0; i < str.length; i++) {
        const chr = str.charCodeAt(i);
        hash = (hash << 5) - hash + chr;
        hash |= 0;
      }
      return hash;
    },

    setLocalData(name, value) {
      if (value != null) sessionStorage.setItem(name, JSON.stringify(value));
      else sessionStorage.removeItem(name);
    },

    getLocalData(name) {
      if (name === "uuid") {
        return sessionStorage.getItem("uuid")?.replaceAll('"', "");
      }
      return JSON.parse(sessionStorage.getItem(name));
    },

    showError(message) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: this.getrans(message),
        confirmButtonColor: "#034a94",
      });
    },

    async selectOtpMethod(method) {
      this.selectedOtpMethod = method;
      this.otpSentMethod = method;
      this.showOtpMethodSelection = false;
      
      if (method === 'sms') {
        await this.sendMobileOtp(this.pendingLoginData.uuid);
      } else {
        await this.sendOtp(this.pendingLoginData.email);
      }

      this.otp_panel_showing = true;
      this.loginSubmitting = false;

      // Initialize Web OTP for SMS
      if (method === "sms") {
        this.requestWebOtp();
        this.showCrossDeviceOption = !this.webOtpSupported;
      }
    },

    async sendPasskeyVerificationOtp() {
      if (!this.validateEmail('regUsername')) return;
      
      try {
        const response = await axios.post('https://devapi-frankfurt.rezcomm.com/webauthdemo/send_otp', {
          email: this.regUsername,
          brand_id: ["SB3", "SB4", "SB5"].includes(this.setbrandid) ? "SB2" : this.setbrandid
        }, {
          headers: {
            'Content-Type': 'application/json',
            'secret_id': 'q3Xy38BMxIoWoEL2TMEKF26VHkoklhfN',
            'secret_key': 'xQ28aghshpJUWB3M2LjbwZAgH1bGI7XDkeLPzpDX50gISx3Y1b'
          }
        });

        if (response.data.success) {
          this.passkeyOtpSent = true;
          this.passkeySessionToken = response.data.session_token;
        } else {
          this.showError(response.data.message || "Failed to send verification code");
        }
      } catch (error) {
        this.showError("Failed to send verification code");
      }
    },

    async verifyPasskeyEmail() {
      if (!this.passkeyOtpCode) {
        this.showError("Please enter the verification code");
        return;
      }

      if (!this.passkeySessionToken) {
        this.showError("Session expired. Please request a new code.");
        return;
      }

      try {
        const response = await axios.post('https://devapi-frankfurt.rezcomm.com/webauthdemo/verify_otp', {
          email: this.regUsername,
          brand_id: ["SB3", "SB4", "SB5"].includes(this.setbrandid) ? "SB2" : this.setbrandid,
          otp_code: this.passkeyOtpCode,
          session_token: this.passkeySessionToken
        }, {
          headers: {
            'Content-Type': 'application/json',
            'secret_id': 'q3Xy38BMxIoWoEL2TMEKF26VHkoklhfN',
            'secret_key': 'xQ28aghshpJUWB3M2LjbwZAgH1bGI7XDkeLPzpDX50gISx3Y1b'
          }
        });

        if (response.data.success) {
          this.passkeyEmailVerified = true;
          this.passkeyOtpSent = false;
          this.passkeyOtpCode = "";
          this.passkeySessionToken = null;
        } else {
          this.showError(response.data.message || "Invalid verification code");
        }
      } catch (error) {
        this.showError("Verification failed");
      }
    },

    async sendLoginPasskeyVerificationOtp() {
      try {
        const response = await axios.post('https://devapi-frankfurt.rezcomm.com/webauthdemo/send_otp', {
          email: this.loginemail,
          brand_id: ["SB3", "SB4", "SB5"].includes(this.setbrandid) ? "SB2" : this.setbrandid
        }, {
          headers: {
            'Content-Type': 'application/json',
            'secret_id': 'q3Xy38BMxIoWoEL2TMEKF26VHkoklhfN',
            'secret_key': 'xQ28aghshpJUWB3M2LjbwZAgH1bGI7XDkeLPzpDX50gISx3Y1b'
          }
        });

        if (response.data.success) {
          this.passkeyOtpSent = true;
          this.passkeySessionToken = response.data.session_token;
        } else {
          this.showError(response.data.message || "Failed to send verification code");
        }
      } catch (error) {
        this.showError("Failed to send verification code");
      }
    },

    async verifyLoginPasskeyEmail() {
      if (!this.passkeyOtpCode) {
        this.showError("Please enter the verification code");
        return;
      }

      if (!this.passkeySessionToken) {
        this.showError("Session expired. Please request a new code.");
        return;
      }

      try {
        const response = await axios.post('https://devapi-frankfurt.rezcomm.com/webauthdemo/verify_otp', {
          email: this.loginemail,
          brand_id: ["SB3", "SB4", "SB5"].includes(this.setbrandid) ? "SB2" : this.setbrandid,
          otp_code: this.passkeyOtpCode,
          session_token: this.passkeySessionToken
        }, {
          headers: {
            'Content-Type': 'application/json',
            'secret_id': 'q3Xy38BMxIoWoEL2TMEKF26VHkoklhfN',
            'secret_key': 'xQ28aghshpJUWB3M2LjbwZAgH1bGI7XDkeLPzpDX50gISx3Y1b'
          }
        });

        if (response.data.success) {
          this.passkeyEmailVerified = true;
          this.passkeyOtpSent = false;
          this.passkeyOtpCode = "";
          this.passkeySessionToken = null;
        } else {
          this.showError(response.data.message || "Invalid verification code");
        }
      } catch (error) {
        this.showError("Verification failed");
      }
    },

    resetPasskeyVerification() {
      this.passkeyEmailVerified = false;
      this.passkeyOtpSent = false;
      this.passkeyOtpCode = "";
      this.passkeySessionToken = null;
    },
  },

  mounted() {
    this.modelShow = false;
    window.addEventListener(
      "loginModel",
      () => {
        this.modelShow = !this.modelShow;
      },
      false
    );

    // Check Web OTP support
    this.checkWebOtpSupport();

    // Handle deep link OTP
    this.handleDeepLinkOtp();

    // Set brand-specific terms and privacy links
    if (this.setbrandid === "NUE") {
      this.privacy_policy_link = "https://www.airport-nuernberg.de/de/datenschutz";
      this.terms_and_conditions_link = "/terms.html";
    } else {
      this.terms_and_conditions_link =
        "https://landinglax.rezcommdev.com/lax/lax-terms-and-conditions.html";
      this.privacy_policy_link = "https://www.flylax.com/legal";
    }
  },

  beforeUnmount() {
    // Release the focus trap if the dialog is still open.
    if (this.deactivateFocusTrap) {
      this.deactivateFocusTrap();
      this.deactivateFocusTrap = null;
    }

    // Clean up Web OTP controller
    if (this.webOtpController) {
      this.webOtpController.abort();
    }
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/sass/normalise.scss";
@import "@/assets/sass/bodyStyle.scss";
@import "@/assets/sass/formStyles.scss";
@import "@/assets/sass/override_brand.scss";

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

#login-model-wrapper {
  width: 100%;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999999999;
  display: flex;
  justify-content: center;
  align-items: flex-start;

  .login-model {
    background: #fff;
    border-radius: 4px;
    box-shadow: 0 8px 8px -4px rgba(0, 0, 0, 0.5);
    pointer-events: all;
    max-width: 600px;
    width: 100%;
    max-height: calc(100% - 2rem);
    overflow-y: auto;
    padding: 0;
    margin: 1rem;
    position: relative;

    @media screen and (max-width: 600px) {
      max-height: 100%;
      margin: 0rem;
    }

    h2 {
      margin-top: 0px;
      font-size: 1.2rem;
      font-weight: bold;
    }

    p,
    li {
      font-size: 1rem;
    }

    button.login-modal-close {
      position: absolute;
      top: 0px;
      right: 0px;
      background: none;
      border: 0;
      font: inherit;
      font-size: 1rem;
      padding: 1rem;
      cursor: pointer;
      color: #fff;
    }
  }
}

.cross-device-option {
  text-align: center;
  margin: 1rem 0;
  padding: 1rem;
  background: #f8f9fa;
  border-radius: 0.5rem;
  border: 1px solid #e9ecef;

  .cross-device-btn {
    background: #007bff;
    color: white;
    border: none;
    padding: 0.75rem 1.5rem;
    border-radius: 0.5rem;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin: 0.5rem auto 0;

    &:hover {
      background: #0056b3;
    }

    i {
      position: static;
      color: white;
    }
  }
}

.tab-buttons {
  display: flex;
  padding: 2rem 0 0rem;
  justify-content: space-evenly;
  background: var(
    --header_banner_background,
    transparent linear-gradient(#0871b9 0%, #034a94 100%) 0% 0% no-repeat
      padding-box
  );
  color: #fff;
  font-weight: bold;
  button {
    background: none;
    border: 0;
    font: inherit;
    color: inherit;
    padding: 1rem;
    position: relative;
    cursor: pointer;
    font-size: 2rem;
    text-align: center;
    opacity: 0.5;
    @media screen and (max-width: 576px) {
      font-size: 1.25rem;
    }
  }

  button.active {
    opacity: 1;
  }

  button.active:after {
    position: absolute;
    bottom: 0;
    height: 0;
    width: 0;
    left: 50%;
    transform: translate(-50%, 0.5rem);
    border: 22px solid transparent;
    border-bottom-color: #fff;
    content: "";
  }
}

.content {
  padding: 1rem 3rem;

  @media screen and (max-width: 600px) {
    padding: 1rem 1rem;
  }
}

.content-box {
  padding: 1rem;
  border: 1px solid #dfdfdf;
  background: #f7f7f7;
  border-radius: 4px;
  margin-bottom: 2rem;

  ul {
    margin: 0;
    padding: 0 0 0 1rem;
  }
}

h3 {
  font-size: 1.5rem;
  padding-bottom: 0.5rem;
  margin-bottom: 2rem;
  border-bottom: 1px solid #dfdfdf;
}

button.proceed {
  position: relative;
  width: 100%;
  flex:1 ;
  padding: 1em 2rem;
  display: block;
  font-family: var(--details_buttons_primary_font_family, inherit);
  font-size: var(--details_buttons_primary_font_size, 1rem);
  font-weight: var(--details_buttons_primary_font_weight, inherit);
  background: var(--details_buttons_primary_background, #034a94);
  color: var(--details_buttons_primary_font_color, #fff);
  border: var(--details_buttons_primary_border, none);
  border-radius: var(--details_buttons_primary_border_radius, 0.25rem);
}

.otp-method-selection {
  margin: 1rem 0;
  padding: 1rem;
  background: #f8f9fa;
  border-radius: 0.5rem;
  border: 1px solid #e9ecef;

  h4 {
    margin: 0 0 1rem 0;
    text-align: center;
  }

  .method-buttons {
    display: flex;
    gap: 1rem;
    justify-content: center;

    .method-btn {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      padding: 0.75rem 1.5rem;
      background: #007bff;
      color: white;
      border: none;
      border-radius: 0.5rem;
      cursor: pointer;

      &:hover {
        background: #0056b3;
      }

      i {
        position: static;
        color: white;
      }
    }
  }
}

.block {
  display: flex;
  flex-direction: column-reverse;
  justify-content: center;
  align-items: flex-start;
  padding: 0;
}

.block input:focus ~ label,
.block input:focus ~ label,
.block.hasValue label,
.block label,
.block label {
  top: 0px;
  font-size: 0.9rem !important;
  font-weight: bold;
  position: relative;
  padding: 0;
}

.block input,
.block select {
  border: 1px solid #dddddd !important;
  border-bottom: none;
  border-radius: 5px;
  font-weight: normal;
}

.block select {
  padding: 1.25rem 1rem;
  width: calc(100% - 2rem);
  box-sizing: initial;
  height: auto;
  min-height: 0px;
}

.block input {
  padding: 1.25rem 1rem;
}

.block select,
.block input {
  border: 1px solid #ddd;
  font-size: 1rem;
}

.error-message {
  color: #e00b27;
  font-size: 0.85rem;
  margin-top: 0.25rem;
}

.block.error input {
  border-color: #e00b27 !important;
}

.login-buttons {
  margin-top: 1rem;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  gap: 1rem;
  width: 100%;
  flex-wrap: wrap;
}

.divider {
  text-align: center;
  margin: 1rem 0;
  position: relative;

  &::before {
    content: "";
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    height: 1px;
    background: #ddd;
  }

  span {
    background: #fff;
    padding: 0 1rem;
    color: #666;
    font-size: 1rem;
    position: relative;
    z-index: 1;
  }
}

.registration-success {
  margin-top: 1rem;

  .success-message {
    text-align: center;
    padding: 1rem;
    background: #d4edda;
    border: 1px solid #c3e6cb;
    border-radius: 0.5rem;
    margin-bottom: 1rem;

    i {
      color: #155724;
      font-size: 2rem;
      margin-bottom: 0.5rem;
      position: static;
    }

    h4 {
      color: #155724;
      margin: 0.5rem 0;
    }

    p {
      color: #155724;
      margin: 0;
    }
  }
}

.login-registration-fallback {
  margin-top: 1rem;
  width: 100%;

  .info-message {
    text-align: center;
    padding: 1rem;
    background: #fff3cd;
    border: 1px solid #ffeaa7;
    border-radius: 0.5rem;
    margin-bottom: 1rem;

    i {
      color: #856404;
      font-size: 1.5rem;
      margin-bottom: 0.5rem;
      position: static;
    }

    p {
      color: #856404;
      margin: 0;
    }
  }

  .back-to-login {
    width: auto;
    padding: 0.75rem;
    background: #6c757d;
    color: white;
    border: none;
    border-radius: 0.25rem;
    margin-top: 1rem;
    cursor: pointer;

    &:hover {
      background: #5a6268;
    }
  }
}

.input-checkbox {
  label {
    margin-top: 3px;
  }

  &.error {
    .checkmark-style {
      border-color: #e00b27 !important;
    }

    label {
      color: #e00b27;
    }
  }
}

label {
  cursor: default !important;
  font-size: 0.9rem;
  margin: 0;
}

.input-checkbox {
  margin: 1rem 0 0;
}

.block.tick:not(.ID-no-icons)::before,
.block.error:not(.ID-no-icons)::before {
  top: unset !important;
  bottom: 1.4rem !important;
  left: calc(100% - 2rem);
}

.email-verification {
  margin: 1rem 0;
  padding: 1rem;
  background: #f8f9fa;
  border-radius: 0.5rem;
  border: 1px solid #e9ecef;

  p {
    margin: 0 0 1rem 0;
    color: #495057;
  }

  .otp-input {
    width: 100%;
    padding: 0.75rem;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    margin-bottom: 1rem;
    text-align: center;
    font-size: 1.2rem;
    letter-spacing: 0.2rem;
  }

  .verify-email-btn,
  .verify-code-btn {
    background: #007bff;
    color: white;
    border: none;
    padding: 0.75rem 1.5rem;
    border-radius: 0.25rem;
    cursor: pointer;
    width: 100%;

    &:hover {
      background: #0056b3;
    }
  }
}

.skip-passkey {
  background: #6c757d;
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 0.25rem;
  cursor: pointer;
  width: 100%;
  margin-top: 1rem;

  &:hover {
    background: #5a6268;
  }
}

.verification-success {
  margin: 1rem 0;

  .success-message {
    text-align: center;
    padding: 1rem;
    background: #d4edda;
    border: 1px solid #c3e6cb;
    border-radius: 0.5rem;

    i {
      color: #155724;
      font-size: 1.5rem;
      margin-bottom: 0.5rem;
      position: static;
    }

    p {
      color: #155724;
      margin: 0;
      font-weight: bold;
    }
  }
}


</style>
